'use client';

import React from 'react';
import WeddingNav from '@/components/WeddingNav';
import Image from 'next/image';

export default function ThemePage() {
  return (
    <main className="bg-buttermilk min-h-screen">
      <WeddingNav />

      {/* Hero Image */}
      <section className="relative w-full overflow-hidden" style={{ height: '75vh' }}>
        <Image
          src="/assets/images/IMG_7429-1777460768896.JPG"
          alt="Indigo shibori hand-dyed fabric with traditional Japanese tie-dye patterns in deep blue tones"
          fill
          priority
          className="object-cover"
          style={{ objectPosition: 'center 30%' }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-deep-navy/5 to-deep-navy/65" />
        <div className="absolute bottom-0 left-0 right-0 z-10 px-8 md:px-16 xl:px-24 pb-10 lg:pb-16 max-w-screen-2xl mx-auto w-full">
          <p className="section-label text-warm-sand mb-4">Boadecea &amp; George · XXIX · VIII · MMXXVI</p>
          <h1 className="font-serif text-display-md text-off-white">
            The inspiration behind the day
          </h1>
        </div>
      </section>

      {/* Body Text */}
      <section className="px-8 md:px-16 xl:px-24 pt-16 pb-24 max-w-screen-2xl mx-auto">
        <div className="max-w-2xl">
          <p className="font-sans text-stone text-base md:text-lg leading-relaxed mb-6">
            Dartmouth, with its colour, history, and beautiful coastal setting, forms the backdrop to a day shaped by the places and influences that mean the most to us.
          </p>
          <p className="font-sans text-stone text-base md:text-lg leading-relaxed mb-6">
            The feel of the day is rooted in a traditional summer wedding, with quiet elegance, thoughtful detail, and a deep connection to the sea and surrounding landscape. Blue sits at the heart of this, flowing through the day in rich coastal, indigo, and inky tones, gently shaped by Dartmouth's maritime history and the natural beauty of the setting.
          </p>
          <p className="font-sans text-stone text-base md:text-lg leading-relaxed mb-6">
            You may notice subtle references woven throughout the day in textures, colours, and small details, with a very gentle nod to Japan through simplicity, craftsmanship, and considered design, balanced by a Scottish thread that celebrates our shared family heritage.
          </p>
          <p className="font-sans text-stone text-base md:text-lg leading-relaxed mb-6">
            If you would like to take inspiration or cues from the overarching theme, we would love you to do so in a way that feels right to you.
          </p>
          <p className="font-sans text-stone text-base md:text-lg leading-relaxed">
            Above all, we want you to feel comfortable and to wear something that feels most authentic to you. For more information, please see the imagined FAQs, or feel free to call or message us at any time. We can't wait to see your interpretations, creativity, and individuality come through on the day.
          </p>
          {/* Dartmouth harbour photo — full width of text column, no cropping */}
          <div className="mt-12 w-full relative">
            <Image
              src="/assets/images/56decb6b-32c8-4163-b585-bab0ec74c278-1777462958221.JPG"
              alt="Dartmouth harbour with colourful boats moored along the waterfront"
              width={1200}
              height={900}
              className="w-full h-auto"
              style={{ display: 'block' }}
            />
            <span
              className="absolute bottom-2 right-2 text-white/70"
              style={{ fontSize: '9px', letterSpacing: '0.02em' }}
            >
              Dartmouth Rivermouth, Dec 25
            </span>
          </div>
        </div>
      </section>
    </main>
  );
}
